export default __webpack_public_path__ + "static/media/audio.03b7fa6b.svg";